import { CallTypes, IDataGridColumnConfiguration, IDisplayInning } from '@trackman/baseball-shared-components';
import { IDataGridValidator } from '@trackman/baseball-shared-components/build/models/DataGrid/IDataGridValidator';
import { PlayRow } from 'models/PlayEditRow/PlayRow';
import { IDataGridError } from '@trackman/baseball-shared-components/build/models/DataGrid/IDataGridError';
import { EditRowColumnName } from 'enums/EditRowColumnName';
import { isSimpleCellEmpty, getErrorMessageForEmptyValues, isPlayerCellEmpty } from './ValidationHelpers';
import { IEditRowPlayer } from '../../interfaces/sessionVerification/plays/IEditRowPlayer';

const simpleValidationColumns: string[] = [
  EditRowColumnName.PitcherDexterity,
  EditRowColumnName.BattingSide,
  EditRowColumnName.Inning,
  EditRowColumnName.PitchCall,
];
const playerValidationColumns: string[] = [EditRowColumnName.Pitcher, EditRowColumnName.Batter, EditRowColumnName.Catcher];
const inPlayValidationColumns: string[] = [EditRowColumnName.HitType, EditRowColumnName.PlayResult];
export const emptyCellValidator: IDataGridValidator = {
  validate: (rows: PlayRow[], columns: IDataGridColumnConfiguration[]) => {
    return rows.map((r) => validateRow(r, columns));
  },
};

const validateRow = (row: PlayRow, columns: IDataGridColumnConfiguration[]) => {
  const errors: IDataGridError[] = [];
  if (row.isWarmup || row.isDeleted) {
    return [];
  }
  columns.forEach((col: IDataGridColumnConfiguration) => {
    if (simpleValidationColumns.includes(col.columnName)) {
      if (isSimpleCellEmpty(row[col.dataKey] as string)) {
        errors.push({
          dataKey: col.dataKey,
          errorMessage: getErrorMessageForEmptyValues(col.columnName),
        });
      }
    } else if (playerValidationColumns.includes(col.columnName)) {
      if (isPlayerCellEmpty(row[col.dataKey] as IEditRowPlayer)) {
        errors.push({
          dataKey: col.dataKey,
          errorMessage: getErrorMessageForEmptyValues(col.columnName),
        });
      }
    } else if (col.columnName === EditRowColumnName.Inning) {
      const inning = row[col.dataKey] as IDisplayInning;
      if (!inning || inning.inningNumber < 1) {
        errors.push({
          dataKey: col.dataKey,
          errorMessage: getErrorMessageForEmptyValues(col.columnName),
        });
      }
    } else if (inPlayValidationColumns.includes(col.columnName)) {
      if (row.pitchCall === CallTypes.InPlay && isSimpleCellEmpty(row[col.dataKey] as string)) {
        errors.push({
          dataKey: col.dataKey,
          errorMessage: getErrorMessageForEmptyValues(col.columnName),
        });
      }
    }
  });
  return errors;
};
